<template>
  <section class="app-main">
    <div class="title">{{ title }}</div>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.fullPath;
    },
    title() {
      const {
        meta: { title = "" },
      } = this.$route;
      return title;
    },
  }
};
</script>

<style lang="scss" scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  height: calc(100vh - 122px);
  width: 100%;
  padding: 20px;
  background: #fff;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  .title {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: #1d2129;
    margin-bottom: 16px;
  }
}
</style>
